<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="modal-header d-flex justify-content-center">
  <img class="logo-pec" src="/content/images/logo_aruba_pec.png" alt="" width="215px" height="48px" />
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <div class="row g-0 py-4 mb-3 danger-bg mt-3">

        <div class="col-1 text-center ps-4 pe-4 mt-2">
          <svg-icon src="content/images/icons/ko.svg"
            [svgStyle]="{ 'width.px':'32', 'height.px':'32', 'vertical-align': 'top' }"></svg-icon>
        </div>
        <div class="col-10 col-sm-11 text-start pl3-sm pe-2">
          <div class="font-24 font-lato fw-bold"
            [innerHTML]="'main.modals.pecConversionExpiration.redStrategy.alertTitle' 
            | translate : { expireDays: expireDays }">
            Alert descrizione</div>
          <div *ngIf="!twoFaEnabled">{{ 'main.modals.pecConversionExpiration.redStrategy.alertDescription' | translate }} </div>
          <div *ngIf="twoFaEnabled">{{ 'main.modals.pecConversionExpiration.redStrategy.alertDescriptionNo2fa' | translate }} </div>

          <div class="mt-2 font-14">
            <a href="{{ urlGuide }}" class="border-0" target="_blank" rel="noopener noreferrer">{{
              'main.modals.pecConversionExpiration.redStrategy.question' | translate }}</a>
            <script>
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({'event': 'GAEvent', 'eventCategory': 'conferma_identita',
                'eventAction': 'click', 'eventLabel': 'Dropdown - Perchè farlo'});
            </script>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="row py-3 mb-3 mt-3">
    <div class="col-12 d-flex justify-content-center col-lg-6">
      <div class="card card-body px-3 py-3 pt-4 pb-4 ps-3">
        <div class="row font-weight-normal align-items-center ps-3">
          <div class="col-5 col-lg-3 font-20 fw-bold "
            [innerHTML]="'main.modals.pecConversionExpiration.identita.labelIdentita' | translate">

          </div>
          <div class="col-6 col-lg-2 text-lg-start ps-3">
            <div class="notIdentified font-12 ps-1 pe-2 w-120px f-r"
              *ngIf="recognitionStatus === 'NotIdentified' || 
                  recognitionStatus === 'IdentificationPending' || 
                  recognitionStatus === 'TerritorioPending'">
              <div class="circleNotIdentified mr-1 displayInline"></div>
              <strong>{{ 'main.modals.pecConversionExpiration.identita.notConfirmed' | translate }}
              </strong>
            </div>
            <div class="checkInProgress font-12 ps-1 pe-2 w-140px f-r"
              *ngIf="recognitionStatus === 'IdentificationInProgress'">
              <div class="circleCheckInProgress mr-1 displayInline"></div>
              <strong>{{ 'main.modals.pecConversionExpiration.identita.checkInProgress' | translate }}
              </strong>
            </div>
            <div class="docRequired font-12 ps-1 pe-2 w-150px f-r"
              *ngIf="recognitionStatus === 'LegalValidationFailed' || recognitionStatus === 'DocumentsRequired'">
              <div class="circleDocRequired mr-1 displayInline"></div>
              <strong>{{ 'main.modals.pecConversionExpiration.identita.missingDoc' | translate }}
              </strong>
            </div>
            <div class="confirm font-12 ps-1 pe-2 w-80px f-r" *ngIf="recognitionStatus ==='OK'">
              <div class="circleConfirm mr-1 displayInline"></div>
              <strong>{{ 'main.modals.pecConversionExpiration.identita.confirmed' | translate }} </strong>
            </div>
          </div>
        </div>
        <div class="row font-weight-normal align-items-center ps-3">
          <div class="col-12 font-14 text-lg-start mt-2" *ngIf="recognitionStatus === 'NotIdentified'">
            <div>
              {{ 'main.modals.pecConversionExpiration.identita.messageNotConfirmed' | translate }}
            </div>
          </div>
          <div class="col-12 font-14 text-lg-start mt-2" *ngIf="recognitionStatus === 'TerritorioPending'">
            <div class="row">
              <div class="col-1">
                <svg-icon src="content/images/icons/time-fast-large.svg"
                  [svgStyle]="{ 'width.px':'24', 'height.px':'24', 'vertical-align': 'middle' }"></svg-icon>
              </div>
              <div class="col-10 ps-1">
                <strong>{{ 'main.modals.pecConversionExpiration.identita.messageTimeFast1' | translate
                  }}</strong><span>{{ 'main.modals.pecConversionExpiration.identita.messageTimeFast2'
                  | translate }} {{ territoryExpireDate | date : 'DD/MM/YYYY' }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 font-14 text-lg-start mt-2" *ngIf="recognitionStatus === 'IdentificationPending'">
            <div class="row">
              <div class="col-1">
                <svg-icon src="content/images/icons/time-fast-large.svg"
                  [svgStyle]="{ 'width.px':'24', 'height.px':'24', 'vertical-align': 'middle' }"></svg-icon>
              </div>
              <div class="col-10 ps-1">
                <strong>{{ 'main.modals.pecConversionExpiration.identita.messageTimeFast1' | translate
                  }}</strong><span>{{ 'main.modals.pecConversionExpiration.identita.messageTimeFast3'
                  | translate }} {{ dvoExpireDate | date : 'DD/MM/YYYY' }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 font-14 text-lg-start mt-2"
            *ngIf="recognitionStatus === 'DocumentsRequired' || recognitionStatus === 'LegalValidationFailed'">
            <div class="row">

              <div class="col-10 ps-3">
                <div>
                  {{ 'main.modals.pecConversionExpiration.identita.messageMissingDoc' | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 font-14 text-lg-start mt-2" *ngIf="recognitionStatus === 'IdentificationInProgress'">
            <div
              [innerHTML]="'main.modals.pecConversionExpiration.identita.messageIdentificationInProgress' | translate">
            </div>
          </div>
          <div class="col-12 font-14 text-lg-start mt-2" *ngIf="recognitionStatus ==='OK'">
            <div>
              {{ 'main.modals.pecConversionExpiration.identita.messageConfirmed' | translate }}
            </div>
          </div>
          <div class="col-12  font-14 text-lg-start mt-2"
            *ngIf="recognitionStatus !=='OK' && recognitionStatus !== 'TerritorioPending' && 
               recognitionStatus !== 'IdentificationPending' && recognitionStatus !== 'DocumentsRequired' && 
               recognitionStatus !== 'LegalValidationFailed' && recognitionStatus !== 'IdentificationInProgress'">
            <svg-icon src="content/images/icons/time-fast.svg"
              [svgStyle]="{ 'width.px':'16', 'height.px':'16', 'vertical-align': 'middle' }"></svg-icon>
            <span [innerHTML]="'main.modals.pecConversionExpiration.identita.messageTime' | translate">
            </span>
          </div>
          <div class="col-12 font-14 text-lg-start  mt-2"
            *ngIf="recognitionStatus !=='OK' && recognitionStatus !== 'TerritorioPending' && 
            recognitionStatus !== 'IdentificationPending' && recognitionStatus !== 'DocumentsRequired' && 
            recognitionStatus !== 'LegalValidationFailed' && recognitionStatus !== 'IdentificationInProgress'">
            <svg-icon src="content/images/icons/user-shield-circle.svg"
              [svgStyle]="{ 'width.px':'16', 'height.px':'16', 'vertical-align': 'middle' }"></svg-icon>
            <span [innerHTML]="'main.modals.pecConversionExpiration.identita.messageWhatIsNeeded1' | translate"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card card-body px-3 py-3 pt-4 pb-4 ps-3">
        <div class="row font-weight-normal align-items-center ps-3">
          <div class="col-7 col-lg-7 font-20 fw-bold"
            [innerHTML]="'main.modals.pecConversionExpiration.verifica2Passaggi.labelVerifica2Pass' | translate">
          </div>
          <div class="col-5 col-lg-2 font-16 text-lg-start ps-3">
            <div class="notIdentified font-12 ps-1 pe-2 w-100px f-r" *ngIf="!twoFaEnabled">
              <div class="circleNotIdentified mr-1 displayInline"></div>
              <strong>{{ 'main.modals.pecConversionExpiration.verifica2Passaggi.notEnabled' | translate }}
              </strong>
            </div>
            <div class="confirm font-12 ps-1 pe-2 w-80px f-r" *ngIf="twoFaEnabled">
              <div class="circleConfirm mr-1 displayInline"></div>
              <strong>{{ 'main.modals.pecConversionExpiration.verifica2Passaggi.enabled' | translate }}
              </strong>
            </div>
          </div>
        </div>
        <div class="row font-weight-normal align-items-center ps-3">
          <div class="col-12 col-lg-8 font-14 text-lg-start mt-2" *ngIf="!twoFaEnabled">
            <div>
              {{ 'main.modals.pecConversionExpiration.verifica2Passaggi.messageNotEnabled' | translate }}
            </div>
          </div>
          <div class="col-12 col-lg-8 font-14 text-lg-start mt-2" *ngIf="twoFaEnabled">
            <div>
              {{ 'main.modals.pecConversionExpiration.verifica2Passaggi.messageEnabled' | translate }}
            </div>
            <div class="pl3-2">&nbsp;</div>
            <div class="pl3-2 pt-24">&nbsp;</div>
          </div>
          <div class="col-12 col-lg-8 font-14 text-lg-start mt-2" *ngIf="!twoFaEnabled">
            <svg-icon src="content/images/icons/time-fast.svg"
              [svgStyle]="{ 'width.px':'16', 'height.px':'16', 'vertical-align': 'middle' }"></svg-icon>
            <span [innerHTML]="'main.modals.pecConversionExpiration.verifica2Passaggi.messageTime' | translate"></span>
          </div>
          <div class="col-12 col-lg-8 font-14 text-lg-start mt-2" *ngIf="!twoFaEnabled">
            <svg-icon src="content/images/icons/mobile-shield.svg"
              [svgStyle]="{ 'width.px':'16', 'height.px':'16', 'vertical-align': 'middle' }"></svg-icon>
            <span 
              [innerHTML]="'main.modals.pecConversionExpiration.verifica2Passaggi.messageWhatIsNeeded' | translate">
            </span>
            <div class="pl3-2">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer border-top-0 justify-content-start mt-3 py-5 mb-5 d-none d-lg-block">
  <div class="row col-12 ps-0 pe-0">
    <div class="col-6" *ngIf="timeLeft > 0">
      <svg class="base-timer base-timer_svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <g class="base-timer_circle">
          <circle class="base-timer_path-elapsed" cx="50" cy="50" r="45"></circle>
          <path id="base-timer-path-remaining" stroke-dasharray="283" class="base-timer_path-remaining"
            d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0">
          </path>
        </g>
      </svg>
      <span id="base-timer-label" class="base-timer_label">{{timeLeft}}</span>
    </div>

    <div class="col-6 pe-0" *ngIf="timeLeft === 0">
      <button type="button" class="btn btn-link font-16 font-lato" (click)="hideAdvise()">{{
        'main.modals.pecConversionExpiration.redStrategy.btnRemember' | translate }}</button>
      <script>
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({'event': 'GAEvent','eventCategory': 'conferma_identita',
          'eventAction': 'click','eventLabel': 'Button - Ricordamelo più tardi'});
      </script>
    </div>
    <div class="col-6 text-end pe-0">
      <div
        *ngIf="(recognitionStatus === 'TerritorioPending' && !twoFaEnabled) || 
          (twoFaEnabled && recognitionStatus === 'NotIdentified') || 
          (recognitionStatus === 'IdentificationPending')">
        <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">
          {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionConfirm' | translate }}
        </button>
      </div>
      <div *ngIf="!twoFaEnabled && recognitionStatus === 'NotIdentified'">
        <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">{{
          'main.modals.pecConversionExpiration.redStrategy.btnPecConversionAlign' | translate }}</button>
      </div>
      <div *ngIf="recognitionStatus === 'TerritorioPending' && twoFaEnabled">
        <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">
          {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionDiscover' | translate }}
        </button>
      </div>
      <div *ngIf="recognitionStatus === 'DocumentsRequired' || recognitionStatus === 'LegalValidationFailed'">
        <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">
          {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionCheck' | translate }}
        </button>
      </div>
      <div *ngIf="!twoFaEnabled && (recognitionStatus === 'IdentificationInProgress' || recognitionStatus === 'OK')">
        <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">
          {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionActive' | translate }}
        </button>
      </div>
      <script>
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({'event': 'GAEvent','eventCategory': 'conferma_identita',
          'eventAction': 'click','eventLabel': 'Button - Adegua la tua PEC'});
      </script>
    </div>
  </div>
</div>
<div class="modal-footer border-top-0 d-md-none d-flex flex-column">
  <div class="ps-0 pe-0">
    <div class="mx-5 px-5 col-8" *ngIf="timeLeft > 0">
      <svg class="base-timer base-timer_svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <g class="base-timer_circle">
          <circle class="base-timer_path-elapsed" cx="50" cy="50" r="45"></circle>
          <path id="base-timer-path-remaining" stroke-dasharray="283" class="base-timer_path-remaining"
            d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0">
          </path>
        </g>
      </svg>
      <span id="base-timer-label2" class="base-timer_label">{{timeLeft}}</span>
    </div>
    <div class="mt-3">
      <div
        *ngIf="(recognitionStatus === 'TerritorioPending' && !twoFaEnabled) || 
        (twoFaEnabled && recognitionStatus === 'NotIdentified') || (recognitionStatus === 'IdentificationPending')">
        <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">
          {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionConfirm' | translate }}
        </button>
      </div>
      <div *ngIf="!twoFaEnabled && recognitionStatus === 'NotIdentified'">
        <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">
          {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionAlign' | translate }}
        </button>
      </div>
      <div *ngIf="recognitionStatus === 'TerritorioPending' && twoFaEnabled">
        <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">
          {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionDiscover' | translate }}
        </button>
      </div>
      <div *ngIf="recognitionStatus === 'DocumentsRequired' || recognitionStatus === 'LegalValidationFailed'">
        <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">
          {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionCheck' | translate }}
        </button>
      </div>
      <div *ngIf="!twoFaEnabled && (recognitionStatus === 'IdentificationInProgress' || recognitionStatus === 'OK')">
        <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">
          {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionActive' | translate }}
        </button>
      </div>
      <script>
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ 'event': 'GAEvent', 'eventCategory': 'conferma_identita',
          'eventAction': 'click', 'eventLabel': 'Button - Adegua la tua PEC'});
      </script>
    </div>
    <div class="text-center mt-3" *ngIf="timeLeft === 0">
      <button type="button" class="btn btn-link" (click)="hideAdvise()">
        {{ 'main.modals.pecConversionExpiration.redStrategy.btnRemember' | translate }}
      </button>
      <script>
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ 'event': 'GAEvent', 'eventCategory': 'conferma_identita',
          'eventAction': 'click', 'eventLabel': 'Button - Ricordamelo più tardi'});
      </script>
    </div>
  </div>
</div>